import * as React from "react";

/**
 * Chip — a micro ATTRIBUTE label ("GATED", "MANUAL", "end state"): tiny,
 * uppercase, bordered, muted. Promoted from the `/styleguide` workflow
 * prototypes (#44205).
 *
 * NOT a status: a state that changes over time renders through
 * `StatusBadge`/`IntentBadge` (frontend rule 10). A Chip names a fixed
 * attribute or classification of the thing beside it — the difference is
 * whether you'd ever expect the label to flip on its own.
 */
export function Chip({ children }: { children: React.ReactNode }) {
  return (
    // badge-ignore: Chip IS the shared micro ATTRIBUTE label atom (fixed classification, not a status that flips). Distinct from StatusBadge/IntentBadge by design — see header comment.
    <span className="rounded border border-border px-1.5 py-0.5 type-subtext font-medium uppercase tracking-wide text-muted-foreground">
      {children}
    </span>
  );
}
